import { ethers } from 'ethers'
import React,{ useState } from 'react'
import { AiFillStar } from 'react-icons/ai'

const styles = {
    won:'text-green-500 px-6 py-4 font-bold',
    lost:'text-red-600 px-7 py-4 font-bold',
}

const FRTableRow = ({ history,index }) => {
    const shadowColor = ['shadow-zinc-400','shadow-red-400', 'shadow-blue-400','shadow-green-400', 'shadow-orange-400']

    // console.log(history[5].toString());
  return (
    <>
        <tr className="bg-black/40 border-b  cursor-pointer">
                <th
                  scope="row"
                  className="px-6 py-4 pt-5 font-bold whitespace-nowrap text-lyellow"
                >
                  {index+1}
                </th>
                <td className="px-6 py-4 ">
                <div className="flex flex-grow text-lyellow items-center">
                        {
                            history[1].map((num,index) => (
                                <p key={index} className={`mr-2 sm:mr-5 shadow-md ${shadowColor[index]} rounded-full px-[0.65em] py-1`}>
                                {num.toString()}
                                </p>
                            ))
                        }
                        {
                            history[2].map((star,index) => (
                                <div className='flex'>
                                    <AiFillStar className="text-[#FFD700] text-sm"/>
                                    <p className="mr-1 sm:mr-5 shadow-md shadow-yellow-500 rounded-full px-[0.7em] py-1">
                                        {star.toString()}
                                    </p>
                                </div>
                            ))
                        }
                      </div>
                </td>
                <td className={history[3]? styles.won : styles.lost} >{history[3] ? "Won": "Lost"}</td>
                <td className="px-7 py-4 text-green-300 font-bold" >${parseFloat(ethers.utils.formatEther(history[4].toString())).toFixed(5)}</td>
                <td className="px-6 py-4 text-purple-500" >{
                    history[5].toString() === "1" ? '5 Numbers + 2 Stars' : history[5].toString() === "2" ? '5 Numbers + 1 Stars' : history[5].toString() === "3" ? '5 Numbers' : history[5].toString() === "4" ? '4 Numbers' : history[5].toString() === "5" ? '3 Numbers' : history[5].toString() === "6" ? '2 Numbers' : 'None'
                }</td>
              </tr>
    </>
  )
}

export default FRTableRow